import "./FullscreenNavigation.scss";
import { Fragment, memo } from "react";
import { BackButton } from "../buttons";
import { RGLogo } from "components/UI/RGLogo";
import { MobileBackButton } from "./MobileBackButton";
import useMediaQuery from "@mui/material/useMediaQuery";

interface IProps {
  embedded?: boolean;
  toggleFullScreen: () => void;
}

const FullscreenNavigation = (props: IProps) => {
  const { toggleFullScreen, embedded } = props;

  const isDesktop = useMediaQuery("(min-width: 655px)");

  return (
    <div className="fsnav">
      {isDesktop ? (
        <Fragment>
          {!embedded && <BackButton onClick={toggleFullScreen} />}
          {<RGLogo />}
        </Fragment>
      ) : (
        <MobileBackButton onClick={toggleFullScreen} />
      )}
    </div>
  );
};

export const FullscreenNavigationMemo = memo(FullscreenNavigation);
